import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=ce056d9e"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=ce056d9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports